import { Mapper } from "../../../../base/utils/mapper";
import { UserValidateOtpModel } from "../../../../domain/models/user/user-validate-otp.model";
import { UserValidateOtpEntity } from "../entities/user-validate-otp.entity";


export class UserValidateOtpImplementationRepositoryMapper extends Mapper<UserValidateOtpEntity, UserValidateOtpModel> {
    mapFrom(param: UserValidateOtpEntity): UserValidateOtpModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserValidateOtpModel): UserValidateOtpEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}